import { useState } from 'react';
import ReactGoogleMapLoader from "react-google-maps-loader"
import ReactGooglePlacesSuggest from "react-google-places-suggest"
import Input from '@byma/shared/components/Input'

export default function SearchAddressInput({ onChange }) {
    const [ search, setSearch ] = useState('')
    const [ value, setValue ] = useState('')

    function handleInputChange(e) {
        setSearch(e.target.value)
        setValue(e.target.value)
    }

    function handleSelectSuggest(geocodedPrediction, originalPrediction) {       
        setSearch('')
        setValue(geocodedPrediction.formatted_address)

        onChange(geocodedPrediction, originalPrediction)
    }

    return (
        <ReactGoogleMapLoader
            params={{
                key: process.env.NEXT_PUBLIC_GOOGLE_API_KEY,
                libraries: "places,geocode",
            }}
            render={googleMaps =>
                    googleMaps && (
                        <ReactGooglePlacesSuggest
                            googleMaps={googleMaps}
                            autocompletionRequest={{
                                input: search,
                            }}
                            onSelectSuggest={handleSelectSuggest}
                            textNoResults="Sem resultados"
                            customRender={prediction => (
                                <div style={{padding: 20, color: 'black'}}>
                                    {prediction
                                        ? prediction.description
                                        : "Sem resultados"}
                                </div>
                            )}
                        >
                            <div className={`box-hover shadow-sm outline outline-transparent relative border rounded focus-within:border-blue-500 flex items-center space-x-2 px-4 py-3`}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                                </svg>
                                <input 
                                    className={`block w-full text-lg appearance-none focus:outline-none bg-transparent` } 
                                    onChange={handleInputChange} 
                                    placeholder="Buscar por nome do local ou endereço..."
                                    value={value}
                                />
                            </div>
                        </ReactGooglePlacesSuggest>
                    )
            }
        />
    )
}
